import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { Column, Row } from 'components/v2/Grid'
import MoreFilters from 'components/v2/MoreFilters'
import TopFilters from 'components/Search/Filters/TopFilters'
import CollapseHeader from 'components/Search/CollapseHeader'
import ResultsController from 'components/v2/ResultsController'

import { collapse } from 'redux/modules/filters'

const Filters = ({ onSearchPsychologists }) => {
  const dispatch = useDispatch()
  const filters = useSelector(state => state.filters)

  const onToggleMoreFiltersVisibility = () => dispatch(collapse())

  useEffect(() => {
    const onScroll = () => {
      const wrapper = document.querySelector('#wrapper-header-search-filters')
      const fixedHeader = document.querySelector('#header-nav-bar')
      const collapseHeader = document.querySelector('#header-search-and-filters')
      const topFilters = document.querySelector('#top-filters')

      if (topFilters && window.location.pathname === '/busca') {
        const isCollapsed = filters?.collapsed
        const isCollapsedHeaderVisible = collapseHeader?.style.opacity === '1'

        if (window.pageYOffset > topFilters.offsetTop) {
          if (wrapper) wrapper.style.zIndex = '800'
          if (isCollapsed && !isCollapsedHeaderVisible) {
            onToggleMoreFiltersVisibility()
          }
          if (collapseHeader) collapseHeader.style.opacity = '1'
          if (fixedHeader) fixedHeader.style.visibility = 'hidden'
        } else {
          if (isCollapsed && isCollapsedHeaderVisible) {
            onToggleMoreFiltersVisibility()
          }
          if (fixedHeader) fixedHeader.style.visibility = 'visible'
          if (collapseHeader) collapseHeader.style.opacity = '0'
          if (wrapper) wrapper.style.zIndex = '-1'
        }
      }
    }

    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [filters?.collapsed])

  return (
    <div>
      <CollapseHeader />
      <Column>
        <Row as='section' id='default-filters' justifyContent='center' mb='3px' bg='white'>
          <TopFilters onSearchPsychologists={onSearchPsychologists} />
          {filters?.collapsed && <MoreFilters onSearchPsychologists={onSearchPsychologists} />}
        </Row>
        <Row justifyContent='center' background='#f8f8f8' wrap={['no-wrap', 'wrap']}>
          <Row as='section' p={['0 15px', '0 10px']} width={['100%', '1140px']} bg='#f8f8f8'>
            <ResultsController />
          </Row>
        </Row>
      </Column>
    </div>
  )
}

export default Filters
